import {
  GET_GEOLOCATION_PENDING,
  GET_GEOLOCATION_REJECTED,
  GET_GEOLOCATION_FULFILLED,
  SAVE_GEOLOCATION_FROM_SESSION_STORAGE,
} from "../../constants/geolocation";

const geolocation = (state = {}, action) => {
  switch (action.type) {
    case GET_GEOLOCATION_PENDING:
      return { ...state, loading: true, error: false, success: false };
    case GET_GEOLOCATION_REJECTED:
      return { ...state, loading: false, error: true, success: false };
    case GET_GEOLOCATION_FULFILLED:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        geolocationData: action.payload.data,
      };
    case SAVE_GEOLOCATION_FROM_SESSION_STORAGE:
      return {
        ...state,
        loading: false,
        error: false,
        success: true,
        geolocationData: action.payload.data,
      };
    default:
      return state;
  }
};

export default geolocation;
